"use client"

import React, { useState, useCallback } from 'react';
import Link from 'next/link';
import Image from 'next/image';

import {
    Card,
    CardContent,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
} from "@/components/ui/card"
import {Label} from "@/components/ui/label"
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group"
import {Button} from "@/components/ui/button"

const Switch = () => {

const imageInfo = [
    { src: '/bike_illu_seatpost.jpg', link: '/fitting/saddle-height', title: 'Seatpost', description: 'Step 1: The Heel-to-Pedal method is a common technique used to set the saddle height on a bicycle to an appropriate level for the rider, which is crucial for comfort and efficiency while cycling. The primary objective of this method is to set the saddle height at a level where the rider can pedal comfortably and efficiently without overextending or under-extending their legs.', value: 'seatpost' },
    { src: '/bike-illu2-saddle.jpg', link: '/fitting/saddle-offset', title: 'Saddle', description: 'Step 2: The Knee Over Pedal Spindle (KOPS) method is a traditional bike fitting technique aimed at finding the proper saddle position to optimize cycling ergonomics and performance. The KOPS method helps in finding a saddle position that facilitates efficient pedaling, which in turn can enhance cycling performance and minimize the risk of injury. The technique primarily aims at achieving a good fore-aft saddle position which is crucial for balanced weight distribution and effective power transfer while cycling​', value: 'saddle' },
    { src: '/bike_illu_cockpit.jpg', link: '/fitting/cockpit',  title: 'Cockpit', description: 'Step 3: Adjusting handlebar reach and height is crucial for both comfort and performance while cycling. The right position can prevent neck, back, and shoulder discomfort and also increase your efficiency and power on the bike. Here&apos;s how to adjust the handlebar reach and height', value: 'cockpit' },
];
const [selectedDescription, setSelectedDescription] = useState(imageInfo[0].description);

const handleImageClick = useCallback((description:string) => {
    setSelectedDescription(description);
}, []);

return (
    <div className="min-h-screen py-6 flex flex-col sm:py-12">

        <div className="container mx-auto p-4">

            <Card className="mb-2">
                <CardHeader></CardHeader>
                <CardContent>
                    <h1 className="scroll-m-20 text-4xl font-extrabold tracking-tight lg:text-5xl">
                        Choose your fitting
                    </h1>
                </CardContent>
                <CardFooter></CardFooter>
            </Card>
            <Card className="mb-2">
                <CardHeader></CardHeader>
                <CardContent className="grid gap-6">
                    <h2 className="scroll-m-20 border-b pb-2 text-3xl font-semibold tracking-tight transition-colors first:mt-0">
                        Fitting Wizard
                    </h2>
                    <p className="leading-7 [&:not(:first-child)]:mt-6">Choose the setting you want to improve. If you want a full bikefitting start with step 1 until you have a good fit and get over to step 2 and then to step 3.</p>
                    <RadioGroup defaultValue={imageInfo[0].value} className="grid grid-cols-3 gap-4">
                        {imageInfo.map((info, index) => (
                            <div key={index} className="relative" onClick={() => handleImageClick(info.description)}>
                                <RadioGroupItem value={info.value} id={info.value} className="peer sr-only" />
                                <Label
                                    htmlFor={info.value}
                                    className="flex flex-col items-center justify-between rounded-md border-2 border-muted bg-popover p-4 hover:bg-accent hover:text-accent-foreground peer-data-[state=checked]:border-primary [&:has([data-state=checked])]:border-primary"
                                >
                                    <Image
                                        alt=""
                                        src={info.src}
                                        height={0}
                                        width={0}
                                        sizes="100vw"
                                        style={{ width: '100%', height: 'auto' }}
                                        className="mb-3"
                                    />
                                    <p className="text-sm text-muted-foreground">{info.title}</p>

                                    <Button variant="link" asChild>
                                        <Link href={info.link}>start now</Link>
                                    </Button>
                                </Label>
                            </div>
                        ))}
                    </RadioGroup>
                    <p className="mb-10">{selectedDescription}</p>



                </CardContent>
                <CardFooter></CardFooter>
            </Card>

        </div>

    </div>
  );
}

export default Switch;
